import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'
import './index.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';

import AccessTokenProvider from './contexts/AccessTokenProvider';
import { SessionStorageItemIds } from './Enums';

//Set the license for mui x pro
import { LicenseInfo } from '@mui/x-license-pro';
import { I18N } from './I18N';
// Azure B2C
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './AuthConfig';
import ThemeProvider from './theme';
import { SettingsProvider } from './components/settings';
import { API_URL } from './Environment';
import { getRouterBasename } from './routerConfig';

I18N.Init(window.navigator.language, ['Master']);

LicenseInfo.setLicenseKey(
  '43b9b7549189a229e58adfc55ed413faT1JERVI6NDE4MzQsRVhQSVJZPTE2ODE1MTM3ODMwMDAsS0VZVkVSU0lPTj0x',
);

// Instantiate outside of the React application so it only gets instantiated once
export const msalInstance = new PublicClientApplication(msalConfig);

if (process.env.NODE_ENV === 'development') {
  sessionStorage.setItem(SessionStorageItemIds.ApiBasePath, 'https://localhost:5079');
} else {
  sessionStorage.setItem(SessionStorageItemIds.ApiBasePath, API_URL);
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();

const ThemedApp = () => {

  return (
    <AccessTokenProvider>
      <SettingsProvider>
        <ThemeProvider>
          <BrowserRouter basename={getRouterBasename(window.location.pathname)}>
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </SettingsProvider>
    </AccessTokenProvider>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<ThemedApp />);
